/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
import axios from 'axios';
import { ENDPOINTS } from 'shared/constants';
import qs from 'qs';
// import constructApiUri from '../util/ApiBaseUri';
// const API_URL = constructApiUri(`${process.env.REACT_APP_MEXPRESS_API_URL}`);

const API_URL = process.env.REACT_APP_MEXPRESS_API_URL;
const PORFOLIO_ADVICE = process.env.REACT_APP_PORFOLIO_ADVICE;
const FUND_FACTSHEET_URL = process.env.REACT_APP_FUND_FACTSHEET_API_URL;
const FINANCIAL_SERVICE = process.env.REACT_APP_FINANCIAL_SERVICE;
const APPOINTMENT_API = process.env.REACT_APP_APPOINTMENT_API;
const APP_TRACKING = process.env.REACT_APP_TRACKING;
const IPDATA_KEY = process.env.REACT_APP_IPDATA_KEY;

const createNewUserIfItNotExist = (error) => {
  const { status } = error.response;
  if (status === 401) {
    const notification = document.getElementById('reset-notification');
    notification.className = 'show';
  }
};


/**
 * PRODUCT ADVICE API
 * */
const getAssetAllocation = async (req) => {
  try {
    let params = qs.stringify({
      clientSegment: req.clientSegment,
      endValidityDate: '20201231',
      frontendCode: 'markaz',
      // investmentType: 'conventional',
      investmentType: req.investmentType,
      startValidityDate: '20191120',
      strategyRiskLevel: req.risk,
      isSharia: req.isSharia,
    });

    if (req.listOfGeography.includes('askGeographically.convo.quick_replies.2')) {
      params += '&geographyReference=kuwait_gcc';
    }
    if (req.listOfGeography.includes('askGeographically.convo.quick_replies.3')) {
      params += '&geographyReference=global';
    }
    if (req.listOfGeography.includes('askGeographically.convo.quick_replies.4')) {
      params += '&geographyReference=developed_market';
    }
    if (req.listOfGeography.includes('askGeographically.convo.quick_replies.5')) {
      params += '&geographyReference=gold_investment';
    }

    const res = await axios.get(`${PORFOLIO_ADVICE}${ENDPOINTS.ASSETS_ALLOCATION}/?${params}`);
    return Promise.resolve(res.data);
  } catch (error) {
    return Promise.reject(error);
  }
};
/** */

const getFinancialGoal = async (body) => {
  try {
    const res = await axios.post(`${FINANCIAL_SERVICE}${ENDPOINTS.FINANCIAL_GOAL}`, body);
    return Promise.resolve(res.data);
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * FUND FACTSHEET API
 * */
const getAllFunds = async (list) => {
  try {
    const res = await axios.get(`${FUND_FACTSHEET_URL}${ENDPOINTS.FUND_FACTSHEET_DETAIL}?fundIds=${list}`);
    return Promise.resolve(res.data);
  } catch (error) {
    return Promise.reject(error);
  }
};
/** */

/**
 * USER API
 * */
const userRegistation = async (uuid) => {
  try {
    const body = {
      channel: 'markaz',
      uuid,
    };
    const res = await axios.post(`${API_URL}/user`, body);
    return Promise.resolve(res.data);
  } catch (error) {
    return Promise.reject(error.response);
  }
};

const updateUser = async (userInfo, body) => {
  try {
    const headers = { 'x-access-token': userInfo.uuid };
    const res = await axios.put(`${API_URL}${ENDPOINTS.USER}/${userInfo._id}`, body, { headers });
    return Promise.resolve(res.data);
  } catch (error) {
    createNewUserIfItNotExist(error);
    return Promise.reject(error.response);
  }
};

const resetUser = async (userInfo) => {
  try {
    const headers = { 'x-access-token': userInfo.uuid };
    const res = await axios.patch(`${API_URL}${ENDPOINTS.USER}/${userInfo._id}`, {}, { headers });
    return Promise.resolve(res.data);
  } catch (error) {
    createNewUserIfItNotExist(error);
    return Promise.reject(error.response);
  }
};
/** */

/**
 * CONVERSATION API
 * */
const getConversation = async (userInfo) => {
  try {
    const headers = { 'x-access-token': userInfo.uuid };
    const res = await axios.get(`${API_URL}${ENDPOINTS.CONVERSATION}/${userInfo._id}`, { headers });
    return Promise.resolve(res.data);
  } catch (error) {
    createNewUserIfItNotExist(error);
    return Promise.reject(error.response);
  }
};
const createConversation = async (body, userInfo) => {
  try {
    const headers = { 'x-access-token': userInfo.uuid };
    const res = await axios.post(`${API_URL}${ENDPOINTS.CONVERSATION}`, body, { headers });
    return Promise.resolve(res.data);
  } catch (error) {
    createNewUserIfItNotExist(error);
    return Promise.reject(error.response);
  }
};

const updateConversation = async (userInfo, dialog, body) => {
  try {
    const headers = { 'x-access-token': userInfo.uuid };
    const res = await axios.put(`${API_URL}${ENDPOINTS.CONVERSATION}/${dialog}/${userInfo._id}`, body, { headers });
    return Promise.resolve(res.data);
  } catch (error) {
    createNewUserIfItNotExist(error);
    return Promise.reject(error.response);
  }
};

const clearConversationHistory = async (userInfo, dialog) => {
  try {
    const headers = { 'x-access-token': userInfo.uuid };
    const res = await axios.patch(`${API_URL}${ENDPOINTS.CONVERSATION}/${dialog}/${userInfo._id}`, {}, { headers });
    return Promise.resolve(res.data);
  } catch (error) {
    createNewUserIfItNotExist(error);
    return Promise.reject(error.response);
  }
};

const resetConversation = async (userInfo) => {
  try {
    const headers = { 'x-access-token': userInfo.uuid };
    const res = await axios.patch(`${API_URL}${ENDPOINTS.CONVERSATION}/${userInfo._id}`, {}, { headers });
    return Promise.resolve(res.data);
  } catch (error) {
    createNewUserIfItNotExist(error);
    return Promise.reject(error.response);
  }
};

/** */

/**
 * STEP API
 * */
const createStep = async (userInfo, steps) => {
  try {
    const body = {
      userId: userInfo._id,
      steps,
    };
    const headers = { 'x-access-token': userInfo.uuid };
    const res = await axios.post(`${API_URL}/step`, body, { headers });
    return Promise.resolve(res.data);
  } catch (error) {
    createNewUserIfItNotExist(error);
    return Promise.reject(error.response);
  }
};

const getStep = async (userInfo) => {
  try {
    const headers = { 'x-access-token': userInfo.uuid };
    const res = await axios.get(`${API_URL}${ENDPOINTS.STEP}/${userInfo._id}`, { headers });
    return Promise.resolve(res.data);
  } catch (error) {
    createNewUserIfItNotExist(error);
    return Promise.reject(error.response);
  }
};

const updateStep = async (userInfo, dialog, status) => {
  try {
    const body = {
      active: true,
      status,
      dialog,
    };
    const headers = { 'x-access-token': userInfo.uuid };
    const res = await axios.put(`${API_URL}${ENDPOINTS.STEP}/${userInfo._id}`, body, { headers });
    return Promise.resolve(res.data);
  } catch (error) {
    createNewUserIfItNotExist(error);
    return Promise.reject(error.response);
  }
};

const resetStep = async (userInfo) => {
  try {
    const headers = { 'x-access-token': userInfo.uuid };
    const res = await axios.patch(`${API_URL}${ENDPOINTS.STEP}/${userInfo._id}`, {}, { headers });
    return Promise.resolve(res.data);
  } catch (error) {
    createNewUserIfItNotExist(error);
    return Promise.reject(error.response);
  }
};

/**
 * drop db
*/
// const dropDb = async () => {
//   try {
//     const headers = { token: 'Phu161251@' };
//     const res = await axios.delete(`${API_URL}/drop-db`, { headers });
//     return Promise.resolve(res);
//   } catch (error) {
//     return Promise.reject(error);
//   }
// };
/** */

const submitAppointment = async (data) => {
  try {
    const res = await axios.post(`${APPOINTMENT_API}${ENDPOINTS.MAKE_APPOINTMENT}`, data);
    return Promise.resolve(res.data);
  } catch (error) {
    return Promise.reject(error.response);
  }
};

const sendEmail = async (data) => {
  try {
    const res = await axios.post(`${APPOINTMENT_API}${ENDPOINTS.EMAIL}`, data);
    return Promise.resolve(res.data);
  } catch (error) {
    return Promise.reject(error.response);
  }
};

/** Asset allocation PDF generation */
const generatePdf = async (data, isSendEmail) => {
  try {
    const res = await axios.post(`${APPOINTMENT_API}/pdf?sendEmail=${isSendEmail}`, data);
    return Promise.resolve(res.data);
  } catch (error) {
    return Promise.reject(error.response);
  }
};

const trackingService = async (body) => {
  try {
    const res = await axios.post(`${APP_TRACKING}`, body);
    return Promise.resolve(res.data);
  } catch (error) {
    return Promise.reject(error.response);
  }
};


const countryDetector = async () => {
  try {
    const res = await axios.get(`https://api.ipdata.co/?api-key=${IPDATA_KEY}`);
    return Promise.resolve(res.data);
  } catch (error) {
    return Promise.reject(error.response);
  }
};

const api = {
  getAssetAllocation,
  getAllFunds,
  userRegistation,
  updateUser,
  resetUser,
  getConversation,
  createConversation,
  updateConversation,
  clearConversationHistory,
  resetConversation,
  createStep,
  getStep,
  updateStep,
  resetStep,
  // dropDb,
  submitAppointment,
  getFinancialGoal,
  sendEmail,
  trackingService,
  countryDetector,

  generatePdf,
};

export default api;
